import { useTranslation } from "react-i18next";

function getBasePath() {
  const path = window.location.pathname;
  if (path.startsWith("/pt")) return "/pt";
  if (path.startsWith("/de")) return "/de";
  return "";
}

export default function Footer() {
  const { t } = useTranslation();
  const basePath = getBasePath();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
              CSSBuy<span className="text-primary-500">BR</span>
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t("footer.disclaimer")}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t("footer.resources")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href={`${basePath}/article/cssbuy-spreadsheet-2026-complete-guide`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t("footer.spreadsheet")}
                </a>
              </li>
              <li>
                <span className="text-sm text-foreground-600">{t("footer.categories")}</span>
              </li>
              <li>
                <span className="text-sm text-foreground-600">{t("footer.guides")}</span>
              </li>
              <li>
                <span className="text-sm text-foreground-600">{t("footer.reviews")}</span>
              </li>
              <li>
                <span className="text-sm text-foreground-600">{t("footer.shipping")}</span>
              </li>
              <li>
                <span className="text-sm text-foreground-600">{t("footer.qc")}</span>
              </li>
              <li>
                <span className="text-sm text-foreground-600">{t("footer.safety")}</span>
              </li>
              <li>
                <span className="text-sm text-foreground-600">{t("footer.faq")}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t("footer.company")}
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-600">{t("footer.about")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer.contact")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer.privacy")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer.terms")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer.affiliate")}</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t("footer.languages")}
            </h4>
            <ul className="space-y-2.5">
              <li><a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">English</a></li>
              <li><a href="/pt" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Portuguese</a></li>
              <li><a href="/de" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Deutsch</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 cssbuybr.link — {t("footer.disclaimer")}
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}